// extracted by mini-css-extract-plugin
module.exports = {"root":"root--ebsSu","list":"list--1NQiK"};